export default "/images/663510510e932002542f891b83db7292.avif";